module.exports = __webpack_public_path__ + "img/two_select.01ea3cf5.png";